import { render } from "./personCard.vue?vue&type=template&id=5a33194c"
import script from "./personCard.vue?vue&type=script&lang=js"
export * from "./personCard.vue?vue&type=script&lang=js"

import "./personCard.vue?vue&type=style&index=0&id=5a33194c&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__